import type { HttpInterceptorFn } from "@angular/common/http";
import { HttpErrorResponse } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import { AppService } from "../../store/app.service";

export const errorInterceptor: HttpInterceptorFn = (request, next) => {
    const router = inject(Router);
    const appService = inject(AppService);

    function normalizeError(error: unknown): unknown {
        if (error instanceof Error) {
            return error;
        }

        if (error instanceof HttpErrorResponse) {
            return handleHttpError(error);
        }

        return error;
    }

    function handleHttpError(error: HttpErrorResponse): HttpErrorResponse | null {
        if (error.status === 401) {
            appService.logout().then(async () => router.navigate(["/login"]));

            return null;
        }

        if (error.status === 403) {
            router.navigate(["/dashboard/forbidden"]);
            return null;
        }

        if (error.status === 404) {
            return error;
        }

        return error;
    }

    return next(request.clone()).pipe(
        catchError((error) => {
            const normalizedError = normalizeError(error);
            if (normalizedError) {
                return throwError(() => normalizedError);
            }

            return throwError(() => error);
        })
    );
};
